import { useContext } from 'react'
import { OrgConfigContext } from './OrgConfigContext'

export const useOrgConfig = () => {
  const context = useContext(OrgConfigContext)
  if (!context) {
    throw new Error('useOrgConfig must be used within an OrgConfigProvider')
  }
  return context
}
